import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { useApi2call } from 'containers/Api2/index.js';
import FormModal from 'components/interaction/FormModal/index.jsx';
import useSchema from './form.js';
import messages from '../messages.js';
import schoolRoleParser from '../SchoolRole/schoolRoleParser.js';

function AddRoleButton(props) {
  const { currentRoles } = props;
  const api2call = useApi2call();
  const navigate = useNavigate();
  async function handleSubmit(values) {
    const body = {
      ...values,
      conversations: {
        inbox: false,
        individualRecipients: false,
      },
    };
    const res = await api2call({
      method: 'POST',
      url: 'sa/schoolroles',
      version: 2,
      body,
      parser: schoolRoleParser,
      withPromise: true,
    });
    navigate(`/admin/users/role/${res.id}`);
  }
  const [show, setShow] = useState(false);
  const schema = useSchema(currentRoles);
  return (
    <>
      <Button variant="light" onClick={() => setShow(true)}><FormattedMessage {...messages.addRole} /></Button>
      <FormModal
        schema={schema}
        title={messages.addRole}
        defaultValues={{ name: '' }}
        onSubmit={handleSubmit}
        show={show}
        size="sm"
        onHide={() => setShow(false)}
      />
    </>
  );
}

AddRoleButton.propTypes = {
  currentRoles: PropTypes.array,
};

export default AddRoleButton;
